import { graphql } from 'GQL/gql';

export const GET_COMPANY_OPPORTUNITIES_DETAILS = graphql(`
  query GET_COMPANY_OPPORTUNITIES_DETAILS($_id: ID!, $personId: ID) {
    companyOpportunityDetails(_id: $_id, personId: $personId) {
      ...CompanyOpportunityDetailsFields
      ads
      contactEmail
      follow
      name
      type
    }
  }
`);
